import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { BulkResizeState } from "store/features/bulkResize/types";
import { setUnit } from "store/features/bulkResize/actions";
import { useAppDispatch, useAppSelector } from "store/store";
import { Unit } from "store/types/unit";

export const useUnit = () => {
    const {
        resizeSettings: { unit },
    } = useAppSelector(bulkResizeSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleChange = (option: Unit) => dispatch(setUnit(option));

    return {
        unit,
        handleChange,
    };
};

const equalityFn = (
    left: BulkResizeState,
    right: BulkResizeState
) => {
    if (left.resizeSettings.unit !== right.resizeSettings.unit) return false;

    return true;
};
